import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { UserService } from 'app/core/user/user.service';
import { CrearTareaModel } from 'app/models/crear-tarea.model';
import { Tarea, TareasResponse } from 'app/models/tareas.model';
import { TipologiasInterface } from 'app/models/tipologias.model';
import { TotalGestionesInterface } from 'app/models/totalesGestionesModel';
import { UtilsService } from 'app/modules/utils-service';
import { environment as env } from 'environments/environments';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { TaskFiltersParams } from '../../../models/tasks-filters-params';

@Injectable({providedIn: 'root'})
export class GestionesService {
    gestiones: BehaviorSubject<TareasResponse> = new BehaviorSubject<TareasResponse>(null)
    totalGestiones: BehaviorSubject<TotalGestionesInterface> =new BehaviorSubject<TotalGestionesInterface>(null)
    gestionesFilterParams: BehaviorSubject<TaskFiltersParams> = new BehaviorSubject(null)

    constructor(private api: ApiService) { }

    get gestiones$() {
        return this.gestiones.asObservable();
    }

    get totalGestiones$() {
        return this.totalGestiones.asObservable();
    }

    set setGestionesFilterParams(value: any) {
        this.gestionesFilterParams.next(value);
    }

    get gestionesFilterParmasValue() {
        return this.gestionesFilterParams.getValue()
    }

    getAllTasks(params?:any){
        let _params = {
            tipoTarea: env.TIPOLOGIA_ID_GESTIONES, 
            ...params
        };

        const url='/tareas'
        return new Promise((resolve, reject)=>{
            this.api.GetMethod(url, _params, 'Error al obtener los datos.')
                .subscribe((response: TareasResponse) => {
                    this.gestiones.next(response); 
                    resolve(response)            
                }, error => {
                    reject(true)
                })
        })
    }
    
    getTotalesGestiones(params?: any){
        const url='/gestion'
        return new Promise((resolve, reject)=>{
            this.api.GetMethod(url, params, 'Error al obtener los total de Gestiones.')
                .subscribe((response: TotalGestionesInterface) => {
                    this.totalGestiones.next(response)
                    resolve(response)                  
                }, error => {
                    reject(true)
                })
        })
    }

    getTipologias(idTipologia:number){
        const url= `/tipologias/${idTipologia}`
        return new Promise((resolve, reject)=>{
            this.api.GetMethod(url, {}, 'Error al obtener datos.')
                .subscribe((response: TipologiasInterface) => {
                    resolve(response)                  
                }, error => {
                    reject(true)
                })
        })
    }

    postGestion(body:CrearTareaModel){
        const url= '/tareas'
        return new Promise((resolve, reject)=>{
            this.api.PostMethod(url, body, {}, 'Error al crear gestión.')
                .subscribe(response => {
                    resolve(response)                  
                }, error => {
                    reject(true)
                })
        })
        
    }
}